<div class="addContainer">
  <form [formGroup]="form">
    <input class="input-item" formControlName="name" id="name" placeholder="Item">
    <button (mousedown)="addNewItem($event)" [disabled]="form.invalid">Add</button>
  </form>
</div>
